// import http from "./http";

// /* ================= ADD ================= */
// export const addSchool = async (data) => {
//   try {
//     const formData = new FormData();

//     formData.append("name", data.name);
//     formData.append("email", data.email);
//     formData.append("password", data.password);
//     formData.append("address", data.address || "");
//     formData.append("status", data.status || "active");

//     if (data.logo) {
//       formData.append("logo", data.logo);
//     }

//     const res = await http.post("school/school?action=add", formData, {
//       headers: { "Content-Type": "multipart/form-data" },
//     });

//     return res.data;
//   } catch (error) {
//     return { status: false, message: error.message };
//   }
// };

// /* ================= GET ALL ================= */
// export const getSchools = async () => {
//   try {
//     const res = await http.get("school/school?action=get");
//     return res.data;
//   } catch {
//     return { status: false };
//   }
// };

// /* ================= GET BY ID ================= */
// export const getSchoolById = async (id) => {
//   try {
//     const res = await http.get(`school/school?action=get&id=${id}`);
//     return res.data;
//   } catch (error) {
//     return { status: false, message: error.message };
//   }
// };

// /* ================= DELETE ================= */
// export const deleteSchool = async (id) => {
//   try {
//     const res = await http.get(`school/school?action=delete&id=${id}`);
//     return res.data;
//   } catch {
//     return { status: false };
//   }
// };

// /* ================= UPDATE ================= */
// export const updateSchool = async (id, data) => {
//   try {
//     const formData = new FormData();

//     formData.append("id", id);
//     formData.append("name", data.name);
//     formData.append("email", data.email);
//     formData.append("password", data.password);
//     formData.append("address", data.address || "");
//     formData.append("status", data.status || "active");

//     if (data.logo) {
//       formData.append("logo", data.logo);
//     }

//     const res = await http.post("school/school?action=update", formData, {
//       headers: { "Content-Type": "multipart/form-data" },
//     });

//     return res.data;
//   } catch (error) {
//     return { status: false, message: error.message };
//   }
// };


import http from "./http";

/* ================= ADD ================= */
export const addSchool = async (data) => {
  try {
    const formData = new FormData();

    formData.append("name", data.name);
    formData.append("email", data.email);
    formData.append("password", data.password);
    formData.append("phone", data.phone); // ✅ ADDED
    formData.append("package_id", data.package_id);
    formData.append("address", data.address || "");
    formData.append("reference_by", data.reference_by || "");
    formData.append("status", data.status || "active");

    if (data.logo) {
      formData.append("logo", data.logo);
    }

    const res = await http.post("school/school?action=add", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (error) {
    return { status: false, message: error.message };
  }
};

/* ================= GET ALL ================= */
export const getSchools = async () => {
  try {
    const res = await http.get("school/school?action=get");
    return res.data;
  } catch {
    return { status: false };
  }
};

/* ================= GET BY ID ================= */
export const getSchoolById = async (id) => {
  try {
    const res = await http.get(`school/school?action=get&id=${id}`);
    return res.data;
  } catch (error) {
    return { status: false, message: error.message };
  }
};

/* ================= DELETE ================= */
export const deleteSchool = async (id) => {
  try {
    const res = await http.get(`school/school?action=delete&id=${id}`);
    return res.data;
  } catch {
    return { status: false };
  }
};

/* ================= UPDATE ================= */
export const updateSchool = async (id, data) => {
  try {
    const formData = new FormData();

    formData.append("id", id);
    formData.append("name", data.name);
    formData.append("email", data.email);
    formData.append("password", data.password);
    formData.append("phone", data.phone); // ✅ ADDED
    formData.append("package_id", data.package_id);
    formData.append("address", data.address || "");
    formData.append("reference_by", data.reference_by || "");
    formData.append("status", data.status || "active");

    if (data.logo) {
      formData.append("logo", data.logo);
    }

    const res = await http.post("school/school?action=update", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (error) {
    return { status: false, message: error.message };
  }
};